"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementService = void 0;
var outcome_1 = require("../outcome/outcome");
var outcome_result_1 = require("../outcome/outcome-result");
var outcome_type_1 = require("../outcome/outcome-type");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var constants_1 = require("../constants");
var StatementService = /** @class */ (function () {
    function StatementService(ruleService) {
        this.ruleService = ruleService;
    }
    StatementService.prototype.isStatement = function (possibleStatement) {
        return possibleStatement.outcome !== undefined;
    };
    StatementService.prototype.ruleTraversal = function (conditionOrRule) {
        if (this.ruleService.isRule(conditionOrRule)) {
            if (conditionOrRule.conditions.length < 2) {
                return conditionOrRule;
            }
            else {
                for (var i = conditionOrRule.conditions.length - 1; i >= 0; i--) {
                    var foundRule = this.ruleTraversal(conditionOrRule.conditions[i]);
                    if (foundRule) {
                        return foundRule;
                    }
                }
                return undefined;
            }
        }
        else {
            // TODO: possible bug here, we should explicitly check isCondition but we don't have the condition service available here
            //       so we just assume it is a condition since there is no other available option
            return undefined;
        }
    };
    StatementService.prototype.findNextAvailableRule = function (statement) {
        if (!statement.rule)
            return undefined;
        var nextAvailableRule = this.ruleTraversal(statement.rule);
        if (!nextAvailableRule)
            return statement.rule;
        return nextAvailableRule;
    };
    StatementService.prototype.getAllLeafRules = function (statement) {
        var _this = this;
        var leafRules = [];
        if (!statement.rule)
            return leafRules;
        var traverseRules = function (rule) {
            if (_this.ruleService.isLeafRule(rule)) {
                leafRules.push(rule);
            }
            else {
                rule.conditions.forEach(function (rule) {
                    if (_this.ruleService.isCondition(rule)) {
                        throw new advanced_logic_error_1.AdvancedLogicError('Unexpected condition found. Code should be unreachable for conditions');
                    }
                    if (_this.ruleService.isRule(rule)) {
                        traverseRules(rule);
                    }
                });
            }
        };
        traverseRules(statement.rule);
        return leafRules;
    };
    StatementService.prototype.eval = function (statement, knowledge) {
        if (!statement.rule || this.ruleService.eval(statement.rule, knowledge)) {
            return new outcome_result_1.OutcomeResult(statement.outcome, outcome_result_1.OutcomeOrigin.Evaluated);
        }
        return new outcome_result_1.OutcomeResult(new outcome_1.Outcome({
            type: outcome_type_1.OutcomeType.Failure,
            params: { id: constants_1.FinalNode },
        }), outcome_result_1.OutcomeOrigin.Fallback);
    };
    return StatementService;
}());
exports.StatementService = StatementService;
